import { SDK } from '@redge-media/fo-js-sdk';
import { HeaderName, Platform, ProductType } from '@/shared/enums';
import { generateUUID } from '@/shared/utils/hash-code';
import getDeviceUID from '@/shared/utils/get-device-uid';
import { getSecureUrl } from '@/shared/utils/url';
import ProductsMap from '@/shared/libs/sdk/products-map';

SDK.setup({
  httpOptions: {
    baseURL: getSecureUrl('/api'),
    headers: {
      [HeaderName.APP_VERSION]: process.env.VUE_APP_VERSION,
      [HeaderName.DEVICE_UID]: getDeviceUID(),
    },
  },
  platform: Platform.EMBEDDED_PLAYER,
});

SDK.factory.update({
  types: ProductType,
  models: ProductsMap,
});

export default ({ $services }) => {
  const subscriber = $services.resolve('subscriber');

  SDK.apiAdapter.http.interceptors.request.use((config) => {
    config.headers[HeaderName.CORRELATION_ID] = generateUUID('client');
    config.params.lang = subscriber.currentLanguage;
    config.params.tenant = subscriber.currentTenant;

    return config;
  });
};
